import { Feature } from '@tencent/workbench';
import BaseTitleBarFeature from '@framework/workbench/common/feature/base-titlebar-feature';

@Feature()
export class PcTopMenuFeature extends BaseTitleBarFeature {
}
